// extracted by mini-css-extract-plugin
export default {"container":"pulzo_container__+jzHL"};